import { render, staticRenderFns } from "./BookingsSummary.vue?vue&type=template&id=78acbbf8&scoped=true"
import script from "./BookingsSummary.vue?vue&type=script&lang=ts"
export * from "./BookingsSummary.vue?vue&type=script&lang=ts"
import style0 from "./BookingsSummary.vue?vue&type=style&index=0&id=78acbbf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78acbbf8",
  null
  
)

export default component.exports